import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

export default function DateInput({ value, onChange, minDate }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="flex flex-col items-start space-y-4 relative">
      <button
        onClick={() => setIsOpen(true)}
        className="md:text-lg md:text-base text-primary-text flex gap-2 items-center font-medium"
      >
        <span className="mt-0">
          {value ? moment(value)?.format("D MMM, YYYY, dddd") : "Add Date"}
        </span>
        <div className="w-[24px] h-[18px]">
          <i className="fi fi-rs-angle-small-down text-[#5D5D5D] text-xl leading-none"></i>
        </div>
      </button>

      {/* DatePicker Component */}
      {isOpen && (
        <DatePicker
          selected={value} 
          onChange={(date) => {
            onChange(date); 
            setIsOpen(false); 
          }}
          onClickOutside={() => setIsOpen(false)} 
          inline 
          minDate={minDate}
        />
      )}
    </div>
  );
}
